import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as blueprintReducer from "containers/Blueprint/reducer";
import * as globalReducer from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Blueprint from "components/Blueprint/Blueprint";

const getId = (props) =>
  props && props.match && props.match.params && props.match.params.blueprintId ? props.match.params.blueprintId : "new";

class BlueprintContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    if (props.blueprint === undefined) {
      props.init();
    }
  }

  render() {
    const { id, blueprint, isLoading } = this.props;

    if ((id !== "new" && blueprint === undefined) || isLoading) {
      return <LoadingIndicator />;
    }

    return <Blueprint {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    init: () => dispatch(blueprintReducer.fetchBlueprint(id)),
    saveBlueprint: (label) => dispatch(blueprintReducer.saveBlueprint(id, label)),
    updateDataField: (field) => dispatch(blueprintReducer.updateDataField(id, field)),

    updateHighlightField: (datasetId, field) => dispatch(galleryReducer.updateHighlightField(datasetId, field)),

    updateType: (type) => dispatch(viewReducer.updateType(type))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  return {
    id: id,
    blueprint: blueprintReducer.getBlueprint(state, id),
    blueprintFields: blueprintReducer.getBlueprintFields(state, id),
    datasets: viewReducer.getDatasets(state),
    canEdit: id === "new" || blueprintReducer.getUserEditPermission(state, id),
    canManagePermissions: blueprintReducer.getUserManagePermissions(state, id),

    isLoading: globalReducer.getIsBlueprintsLoading(state),

    isBlueprintCreating: globalReducer.getIsBlueprintCreating(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(BlueprintContainer);
